<template lang="html">
  <section class="HeroJerkBlock">
    <div class="container">
      <div class="columns">
        <div class="column is-5 is-offset-1">
          <div class="WeekHero">
            <h4 class="is-padded is-pulled-left">Ukas helt 😚</h4>
            <div :style="{position: 'relative', paddingBottom: '40px'}">
              <image-source 
                :source="hero.image.asset.url" 
                :widths="widths" 
                :ratio=1.78 
                :alt="hero.name" 
              />
              <div class="HeroJerk-titleContainer">
                <h3 
                  class="HeroJerk-title is-padded has-text-centered" 
                  @click="displayHeroText = !displayHeroText"
                >
                  {{hero.name}} 
                  <icon name="chevron-down" v-if="!displayHeroText"></icon>
                  <icon name="chevron-up" v-if="displayHeroText"></icon>
                </h3> 
              </div>             
            </div>

            <transition name="slide-down">
              <div class="HeroJerk-textContainer" v-if="displayHeroText">
                <p><pre>{{hero.text}}</pre></p>
              </div>
            </transition>
          </div>
        </div>
        <div class="column is-5">
          <div class="WeekJerk">
            <h4 class="is-padded is-pulled-left">Ukas dust 😣</h4>
            <div :style="{position: 'relative', paddingBottom: '40px'}">
              <image-source 
                :source="jerk.image.asset.url" 
                :widths="widths" 
                :ratio=1.78 
                :alt="jerk.name" 
              /> 
              <div class="HeroJerk-titleContainer">
                <h3 
                  class="HeroJerk-title is-padded has-text-centered" 
                  @click="displayJerkText = !displayJerkText"
                >
                  {{jerk.name}} 
                  <icon name="chevron-down" v-if="!displayJerkText"></icon>
                  <icon name="chevron-up" v-if="displayJerkText"></icon>
                </h3> 
              </div>                     
            </div>
            <transition name="slide-down">
              <div class="HeroJerk-textContainer" v-if="displayJerkText">
                <p><pre>{{jerk.text}}</pre></p>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/chevron-up'
import ImageSource from '@/components/ImageSource'

export default {
  props: ['hero', 'jerk'],
  name: 'hero-jerk-block',
  components: {
    Icon,
    ImageSource
  },
  data () {
    return {
      displayHeroText: false,
      displayJerkText: false,
      widths: ['500', '500', '500'],
      width: null
    }
  }
}
</script>

<style lang="sass">
  @import '../assets/stylesheets/_variables.sass'

  .HeroJerkBlock
    padding: $baseline * 4 0
    background-color: lighten($blackish, 73%)

  .WeekHero, .WeekJerk
    padding: 22px
    text-align: center

  .WeekHero
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAOklEQVQoU2N8buL6X/LMbkYGPACvJEgfyBC8imC24FSE7AysitDdiaEIm0dQFOHyKVwRvqAAKyIUVgCUxyJpUWJw6AAAAABJRU5ErkJggg==) repeat
    h3.HeroJerk-title, h4
      color: $red

  .WeekJerk
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAOklEQVQoU2MMnbPy/+qUcEYGPACvJEgfyBC8imC24FSE7AysitDdiaEIm0dQFOHyKVwRvqAAKyIUVgDWbSKjuVINmgAAAABJRU5ErkJggg==) repeat
    h3.HeroJerk-title, h4
      color: $blue

  .HeroJerk-textContainer
    padding: 10px
    background-color: #fff
    text-align: left
    p
      margin-bottom: 22px
      pre
        white-space: pre-wrap
        word-wrap: break-word
        font-family: $family-sans-serif
        color: $blackish

  .HeroJerk-titleContainer
    position: absolute
    width: 100%
    
  .HeroJerk-title
    margin-top: -44px
    margin-bottom: 10px
    max-width: 80%
    &:hover
      cursor: pointer

  .slide-down-enter-active
    transition: all .3s ease

  .slide-down-leave-active
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .slide-down-enter, .slide-down-leave-to
      transform: transelateY(10px)
      opacity: 0

</style>



// WEBPACK FOOTER //
// src/components/HeroJerkBlock.vue